import * as React from 'react';
import './index.css';
import { withTranslation } from '@sailor/i18n-mach-pro';
import { connect } from '@wmfe/mach-pro-store';
import { RootState } from '@/src/pages/homepage/home_page_main/models/store';
import ShopCard from '@/src/pages/channel_list/components/ShopCard/card_container';
import { reportBizCardMetrics, findTargetFromMatrix } from '@/src/utils/bizCardReporter';
import { LxFilterParams, reportProductCardMc, reportProductCardMv } from './lxReport';

const mapStateToProps = (state: RootState) => ({
  filterPanelData: state.global.filterPanelData,
  feedAPIData: state.global?.feedAPIData,
  pageNo: state.global?.pageNo,
});

type BaseIProps = ReturnType<typeof mapStateToProps>;

interface IProps extends BaseIProps {
  apiData?: any;
  bizTraceId?: string;
}
interface IState {
}

class ChannelListShopCard extends React.Component<IProps, IState> {
  keyDomRef: any = null;
  observer: any = null;

  constructor(props) {
    super(props);
  }

  attrChecker = (): void => {
    const data = this.props?.apiData?.json_data || {};
    const {
      shopMainPicUrl,
      content,
      scheme
    } = data || {};

    const shopMainPicMissing = shopMainPicUrl ? 0 : 1;
    const shopNameMissing = findTargetFromMatrix(content, 'shopName')?.name ? 0 : 1;
    const shopJumpUrlMissing = scheme ? 0 : 1;

    reportBizCardMetrics({
      params: {
        shopMainPicMissing,
        shopNameMissing,
        shopJumpUrlMissing
      },
      tags: {
        channel: '【老】店铺商卡'
      }
    });
  }

  /**
     * 曝光监听
     */
  observerCellAppear = () => {
    this.removeObserver();
    if (globalThis?.eventBus?.subscribeCellAppear) { // 新主包通过监听appear通知上报MV
      this.observer = globalThis?.eventBus?.subscribeCellAppear?.(this.props.apiData?.indexPath, (data) => {
        this.lxReportOnShow(this.props.apiData);
      });
    } else { // 兼容旧主包
      this.lxReportOnShow(this.props.apiData);
    }
  }

  removeObserver = () => {
    if (!this.observer) {
      return;
    }

    this.observer?.unSubscribe?.();
  }

  handleFilterParams = () => {
    const { sortOptions, filterOptions } = this.props.filterPanelData?.json_data || {};
    let sort_code = '';
    let sort_name = '';
    if (sortOptions) {
      sortOptions?.sortOptionValues?.forEach((item) => {
        if (item.isSelected) {
          sort_code = item.sortCode;
          sort_name = item.sortName;
        }
      });
    }
    const filter_code_array: string[] = [];
    const filter_name_array: string[] = [];
    if (filterOptions) {
      filterOptions.forEach((filterOption) => {
        filterOption.filterOptionValues.forEach((item) => {
          if (item.isSelected) {
            filter_code_array.push(item.filterId);
            filter_name_array.push(item.filterDisplayName);
          }
        });
      });
    }
    const filter_code = filter_code_array.join(';');
    const filter_name = filter_name_array.join(';');
    const lxFilterParams: LxFilterParams = {
      sort_code,
      sort_name,
      filter_code,
      filter_name,
    };
    return lxFilterParams;
  }

  lxReportOnClick = () => {
    const lxFilterParams = this.handleFilterParams();
    const bizTraceId = this.props.bizTraceId || '-999';
    reportProductCardMc(this.props.apiData?.log_info?.cid, this.props.apiData?.json_data, this.props.apiData?.indexPath.item, bizTraceId, lxFilterParams);
  }

  lxReportOnShow = (apiData) => {
    const { json_data: data } = apiData || {};
    if (data?.isMV) {
      return;
    }

    this.attrChecker();
    // 由于外部传入的时 CloneDeep 的数据，在列表数据更新时会导致 isMv 标志丢失, 造成 MV 上报重复，所以需要在全局做 MV 上报记录
    const mvKey = `${apiData?.indexPath?.item}_key`;
    if (globalThis.homeProductCardMVHistory === undefined) {
      globalThis.homeProductCardMVHistory = {};
    }
    // 如果第一个卡片要被重新曝光了，证明筛选条件已经发生变化或发生刷新，需要清空全局历史上报记录
    if (apiData?.indexPath?.item === 0 && this.props.pageNo === 0) {
      // 第一个数据会进行多次渲染，防止多次清空
      if (!this.props.feedAPIData?.isClearHomeProductCardMVHistory) {
        globalThis.homeProductCardMVHistory = {};
        this.props.feedAPIData.isClearHomeProductCardMVHistory = true;
      }
    }
    if (globalThis.homeProductCardMVHistory[mvKey]) {
      return;
    }
    const lxFilterParams = this.handleFilterParams();
    const bizTraceId = this.props.bizTraceId || '-999';
    reportProductCardMv(this.props.apiData?.log_info?.cid, this.props.apiData?.json_data, this.props.apiData?.indexPath.item, bizTraceId, lxFilterParams);
    data.isMV = true;
    globalThis.homeProductCardMVHistory[mvKey] = true;
  }

  render() {
    this.observerCellAppear();
    const { json_data, layout_info } = this.props.apiData || {};
    const {
      margin_top, margin_bottom, margin_left, margin_right
    } = layout_info || {};
    const itemKey = `itemKey${this.props.apiData?.indexPath?.item}`;
    return (
      <view
        key={itemKey} className="container" style={{
          marginTop: margin_top || 0, marginBottom: margin_bottom || 12, marginLeft: margin_left || 12, marginRight: margin_right || 12
        }}
      >
        <ShopCard data={json_data} lxReportOnClick={this.lxReportOnClick} />
      </view>
    );
  }
}

export default connect(mapStateToProps)(withTranslation('', {
  withRef: true
})(ChannelListShopCard));
